const helperFunctions = {
  methods: {
    get (object, property = '', defaultAnswer = null) {
      let path = property.split('.')
      let currentObject = object
      path.some(property => {
        if (currentObject[property]) {
          currentObject = currentObject[property]
          return false
        } else {
          currentObject = defaultAnswer
          return true
        }
      })
      return currentObject
    },
    substitute (item) {
      let regex = '{([^}]*)}}'
      var tmpStr = item.match(new RegExp(regex, 'g'))
      tmpStr.forEach(property => {
        let tempPath = property.match(new RegExp('(?<={{)(.*)(?=}})', 'g'))
        if (tempPath && tempPath[0]) {
          let path = tempPath[0].split('.')
          let propMain = path.shift()
          let getThis = this.get(this[propMain], path.join('.'))
          if (getThis) {
            item = item.replace(property, getThis)
          } else {
            item = item.replace(property, '')
          }
        }
      })
      return item
    }
  }
}

export default helperFunctions
